module.exports = __webpack_public_path__ + "static/media/front.83ebba28.jpg";